import type { FC } from "react";
import { useState } from "react";

import type { IconName } from "@similarweb/icons";
import { IconButton } from "@similarweb/ui-components";

import { requestFeature } from "pro-features/components/Modals/src/HookModal/services/requestFeature";
import { translate } from "app/filters/i18nFilter";
import GrandAccessBanner from "app/pages/sales-intelligence/common-components/GrandAccessBanner/GrandAccessBanner";
import { SI_CONTACTS_HOOK_ID } from "app/pages/sales-intelligence/constants/common";
import managementTrackingService from "app/pages/sales-intelligence/modules/management/services/tracking/managementTrackingService";
import { resolveSignalsApiCustomAttributes } from "app/pages/sales-intelligence/modules/management/services/tracking/utils";
import { useSignalsApiStatusPollingQuery } from "app/pages/sales-intelligence/modules/management/sub-modules/signals-api/query/queries/useSignalsApiStatusPollingQuery";
import { SuccessBannerContent } from "app/pages/sales-intelligence/sub-modules/signals/components/shared/IntentDataBanner/SuccessBannerContent";

interface IIntentDataBanner {
    title: string;
    description: string;
    iconImagePath: string;
    buttonText: string;
    buttonIconName: IconName;
}

export const IntentDataBanner: FC<IIntentDataBanner> = ({
    title,
    description,
    buttonText,
    buttonIconName,
    iconImagePath,
}) => {
    const [isShowSuccess, setIsShowSuccess] = useState<boolean>(false);
    const { data } = useSignalsApiStatusPollingQuery();
    return (
        <>
            {!isShowSuccess ? (
                <GrandAccessBanner
                    title={title}
                    description={description}
                    iconImagePath={iconImagePath}
                    button={
                        <IconButton
                            type={"trial"}
                            onClick={() => {
                                managementTrackingService.trackSignalApiClickEvent(
                                    `signals API domains/speak with us`,
                                    resolveSignalsApiCustomAttributes(data),
                                );
                                requestFeature(SI_CONTACTS_HOOK_ID);
                                setIsShowSuccess(true);
                            }}
                            iconName={buttonIconName}
                        >
                            {buttonText}
                        </IconButton>
                    }
                />
            ) : (
                <SuccessBannerContent
                    title={translate("hook_modal.get_feature.success.title")}
                    subTitle={translate("si.modal.get_feature.success.subtitle.v-2")}
                />
            )}
        </>
    );
};
